import type { WidgetGridLayout } from '@trinity/chat';

export function getBlockById(instance: WidgetGridLayout, blockId: string) {
  return instance.blocks.find((block) => block.id === blockId) || null;
}

export function getSectionById(instance: WidgetGridLayout, blockId: string, sectionId: string) {
  const block = getBlockById(instance, blockId);
  if (!block) return null;
  return block.sections.find((section) => section.id === sectionId) || null;
}

/**
 * Returns the display title for the block that contains the given widget ID.
 * Prefers the explicit block title; falls back to the tag name if set.
 */
export function getBlockTitleForWidget(instance: WidgetGridLayout, widgetId: number): string | undefined {
  for (const block of instance.blocks) {
    if (block.widgetId === widgetId) {
      return block.title ?? block.tag?.tagName;
    }
    if (block.sections) {
      for (const section of block.sections) {
        for (const item of section.contentItems) {
          if (item.type === 'widget' && item.widgetId === widgetId) {
            return block.title ?? block.tag?.tagName;
          }
        }
      }
    }
  }
  return undefined;
}

/**
 * Returns all widget IDs in the grid in left-to-right, top-to-bottom reading order.
 * For block level widgets (block.widgetId), the widgetId is included directly.
 * For section-based blocks, contentItems are traversed left-to-right within each section.
 */
export function getOrderedWidgetIds(instance: WidgetGridLayout): number[] {
  const ids: number[] = [];

  for (const block of instance.blocks) {
    if (block.widgetId !== undefined) {
      ids.push(block.widgetId);
    } else if (block.sections) {
      for (const section of block.sections) {
        for (const item of section.contentItems) {
          if (item.type === 'widget') {
            ids.push(item.widgetId);
          }
        }
      }
    }
  }

  return ids;
}
